import React from "react";
import PropsType from "prop-types";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";

import { Button, Input } from "antd";
import filter from "../images/filter.png";

const { Search } = Input;

function ContentSearch(props) {
  const {
    toggleFilterForm,
    showFilterForm = true,
    // allowClear = false,
    inputName = props.contentType && props.contentType === "wiki"
      ? "keyword"
      : "search",
    other,
  } = props;

  const history = useHistory();
  const { url } = useRouteMatch();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  const suffix = (
    <Button icon={<img src={filter} alt="" />} onClick={toggleFilterForm} />
  );

  return (
    <div className="ContentSearch">
      <Search
        size="large"
        enterButton
        addonBefore={showFilterForm ? suffix : ""}
        placeholder="جستجو..."
        defaultValue={searchParams.get(inputName)}
        allowClear={true}
        onSearch={(value) => {
          history.push({
            pathname: `${url}`,
            search: value ? `?${inputName}=${encodeURIComponent(value)}` : null,
          });
        }}
        {...other}
      />
    </div>
  );
}

ContentSearch.propTypes = {
  allowClear: PropsType.bool,
};

ContentSearch.defaultProps = {
  allowClear: false,
};

export default ContentSearch;
